import { ModesOfService, CargoTypes } from 'src/Library/Constants';
import { ORGANISATION_SIZE } from '../components/pages/Enquiry/constants';
export interface MasterData {
  sortBy: SortBy;
  dimensionData: DimensionData;
  plantToLoadingPortsMap: PlantToLoadingPortsMap;
  dimensions: PLANT[];
  modules: Modules;
  userData: UserData;
  globalShippingLines: GlobalShippingLine[];
  globalCarriers: GlobalCarrier[];
  permissions: Permissions;
  isTestOrg: boolean;
  rfqPermissibleEntities: any[];
  rfq: Rfq;
  exim: Exim;
  containerTracking: ContainerTracking;
  organisationMasterCategories: OrganisationMasterCategory[];
  currencySymbols: CurrencySymbols;
  containerList: ContainerList[];
  rateTypes: RateType[];
  cargoList: CargoList[];
  cargoTypeList: RateType[];
  organisationOnboardingStatusMaster: RateType[];
  backgroundJobsMasterData: BackgroundJobsMasterData;
  newShipmentView: boolean;
  bookingTermsAndConditions: string;
  show_task_workflow: boolean;
  organisationName: string;
  execution: Execution;
  inttraCode: string;
  bookingStatus: RateType[];
  bookingInttraStatus: RateType[];
  bookingMasterData: BookingMasterData;
  locationPreferences: RateType[];
  vehicleTypeSizeList: VehicleTypeSizeList[];
  domesticVehicleTypeSizeList: VehicleTypeSizeList[];
  consignorAddressTypes: RateType[];
  organisationModesOfService: ModesOfService[];
  termsAndConditions: string;
}

interface VehicleTypeSizeList {
  key: Key;
  value: string;
  label: Key;
}

interface BookingMasterData {
  freightTerms: RateType[];
  payer: RateType[];
  chargeTypes: RateType[];
  containersWithInttraBookingDisabled: Key[];
}

export enum PREFILL_PLANT_ADDRESS_TYPE {
  ORIGIN = 'origin',
  DESTINATION = 'destination',
}

export interface Execution {
  mode: Record<ModesOfService, string>;
  type: Type;
  cargoType: CargoTypes;
  shippingModeToValidIncotermMapping: ShippingModeToValidIncotermMapping;
  allowedPickupAndDrop: string[];
  shippingModeToValidServicesMapping: ShippingModeToValidIncotermMapping;
  locationTypeAtOriginAndDestination: string[];
  validCargoTypeToCargoSubtypeMapping: ValidCargoTypeToCargoSubtypeMapping;
  validDimensionUnits: string[];
  validWeightUnits: string[];
  validVolumeUnits: string[];
  validOtherUnits: string[];
  validContainerSizes: string[];
  validContainerTypes: ValidContainerTypes;
  validLCLPackageTypes: ValidLCLPackageTypes;
  validAirCargoPackageTypes: ValidAirCargoPackageTypes;
  allowedDocumentTypes: AllowedDocumentTypes;
  validContainerOrPackageTypesBasedOnMode: ValidContainerOrPackageTypesBasedOnMode;
  validContainerTypesForCargoFCL: ValidCargoTypeToCargoSubtypeMapping;
  moduleNamesForCustomFields: ModuleNamesForCustomFields;
  validMeasurementUnitsByType: ValidMeasurementUnitsByType;
  allowCases: boolean;
  allowSkuNumber: boolean;
  organisationId?: string;
  prefill_plant_with_destination_or_origin_address?: PREFILL_PLANT_ADDRESS_TYPE;
}

interface ValidMeasurementUnitsByType {
  DIMENSION: string[];
  WEIGHT: string[];
  VOLUME: string[];
  UNITS: string[];
}

interface ModuleNamesForCustomFields {
  CONTAINER_TRACKING: string;
  EXECUTION: string;
}

interface ValidContainerOrPackageTypesBasedOnMode {
  FCL: ValidContainerTypes;
  LCL: ValidLCLPackageTypes;
  AIRCARGO: ValidAirCargoPackageTypes;
}

interface AllowedDocumentTypes {
  MSDS: string;
  'PACKING LIST': string;
  'CUSTOM INVOICE': string;
  'INSURANCE COPY': string;
  'PICKUP REQUEST FORM': string;
  'CUSTOM INVOICE/PL': string;
  OTHER: string;
  DO: string;
  ATTACHMENT: string;
}

interface ValidAirCargoPackageTypes {
  BOX: string;
  ROLL: string;
  PALLET: string;
  BALE: string;
  CARTON: string;
  OVAL_ROLL: string;
  OTHER: string;
}

interface ValidLCLPackageTypes {
  BOX: string;
  ROLL: string;
  PALLET: string;
  DRUM: string;
  IBC: string;
  OVAL_ROLL: string;
  OTHER: string;
}

interface ValidContainerTypes {
  STANDARD: string;
  ISO_TANKS: string;
  REFRIGERATED: string;
  OPEN_TOP: string;
  FLAT_RACK: string;
  HEAVY_DUTY: string;
}

interface ValidCargoTypeToCargoSubtypeMapping {
  GENERAL: string[];
  HAZARDOUS: string[];
  REEFER: string[];
}

interface ShippingModeToValidIncotermMapping {
  AIRCARGO: string[];
  LCL: string[];
  FCL: string[];
}

interface Type {
  IMPORT: string;
  EXPORT: string;
  TRADE: string;
}
interface CargoType {
  GENERAL: string;
  HAZARDOUS: string;
  REEFER: string;
}

interface Mode {
  FCL: string;
  LCL: string;
  AIRCARGO: string;
}

interface BackgroundJobsMasterData {
  statusList: StatusList[];
  requestTypeList: RequestTypeList[];
}

interface RequestTypeList {
  key: string;
  name: string;
  isInternalJob: boolean;
}

interface StatusList {
  key: string;
  name: string;
}

interface CargoList {
  key: Key2;
  value: string;
  label: Key2;
  showAlways: boolean;
  id: string;
}

interface Key2 {
  cargo: string;
  product: string;
}

interface RateType {
  key: string;
  label: string;
}

interface ContainerList {
  key: Key;
  value: string;
  label: Key;
  cargoList: string[];
  id: string;
}

interface Key {
  type: string;
  size: string;
}

interface CurrencySymbols {
  USD: string;
  INR: string;
  EUR: string;
  JPY: string;
  SGD: string;
  MYR: string;
  THB: string;
  IDR: string;
  PHP: string;
  VND: string;
}

interface OrganisationMasterCategory {
  name: string;
  code: string;
}

interface ContainerTracking {
  trackingRequestTagList: PLANT[];
  blRegexshippingLineMap: BlRegexshippingLineMap;
  containerRegexshippingLineMap: ContainerRegexshippingLineMap;
  colourStatusMapping: ColourStatusMapping;
  containerExceptions: PLANT[];
}

interface ColourStatusMapping {
  REACHED_DESTINATION_PORT: string;
  DELAYED: string;
  ON_TIME: string;
  ARRIVING_EARLY: string;
}

interface ContainerRegexshippingLineMap {
  '^MAEU.*': string;
  '^9[0-9]{8}$': string;
  '^EID.*': string;
  '^AIS.*': string;
  '^EEV.*': string;
  '^AMC.*': string;
  '^CED.*': string;
  '^MEDU.*': string;
  '^COSU.*': string;
  '^COAU.*': string;
  '^ONEY.*': string;
  '^EGLV.*': string;
  '^10[0-9]{10}': string;
  '^YMLU.*': string;
  '^AKV.*': string;
  '^MUN.*': string;
  '^HZR.*': string;
  '^ZIMU.*': string;
  '^HDMU.*': string;
  '^NSLK.*': string;
  '^NSSQ.*': string;
  '^NSNS.*': string;
  '^NSAD.*': string;
  '^NSAU.*': string;
  '^HLCU.*': string;
  '^SAFM.*': string;
  '^GOSU.*': string;
  '^GSLU.*': string;
  '^SUDU.*': string;
  '^EPIR.*': string;
  '^AAK.*': string;
  '^OOLU.*': string;
  '^SCJU.*': string;
}

interface BlRegexshippingLineMap {
  '^MAEU.*': string;
  '^9[0-9]{8}$': string;
  '^EID.*': string;
  '^AIS.*': string;
  '^EEV.*': string;
  '^AMC.*': string;
  '^CED.*': string;
  '^MEDU.*': string;
  '^COSU.*': string;
  '^COAU.*': string;
  '^ONEY.*': string;
  '^EGLV.*': string;
  '^10[0-9]{10}': string;
  '^YMLU.*': string;
  '^AKV.*': string;
  '^MUN.*': string;
  '^HZR.*': string;
  '^ZIMU.*': string;
  '^HDMU.*': string;
  '^NSLK.*': string;
  '^NSSQ.*': string;
  '^NSNS.*': string;
  '^NSAD.*': string;
  '^NSAU.*': string;
  '^HLCU.*': string;
  '^SAFM.*': string;
  '^GOSU.*': string;
  '^GSLU.*': string;
  '^SUDU.*': string;
  '^EPIR.*': string;
  '^AAK.*': string;
  '^OOLU.*': string;
  '^SCJU.*': string;
  '^PNC.*': string;
  '^KMTC.*': string;
  '^BKKCB.*': string;
}

interface Exim {
  rakeStatus: PLANT[];
  soStatus: PLANT[];
}

interface Rfq {
  rfqPlanModeTypeAndSubTypeList: RfqPlanModeTypeAndSubTypeList[];
  customCharges: CustomCharge[];
  containerSize: PLANT[];
  rfqPlanStatus: PLANT[];
  period: PLANT[];
  rfqStatus: PLANT[];
  lineItemStatusList: LineItemStatusList;
  bidsOrderedByFilter: PLANT[];
  termsAndConditionsForRfq: TermsAndConditionsForRfq[];
  excelFieldMap: ExcelFieldMap;
  regions: Region[];
  incoterms: Incoterms;
  shipmentSize: ShipmentSize;
  cargoTypeList: PLANT[];
  productList: ProductList[];
  procurementChargeTypeList: PLANT[];
  rfqFrequency: string[];
  airRfqFrequency: string[];
  conditionTypeItemNameAndDescriptionList: ConditionTypeItemNameAndDescriptionList[];
  dryPortWetPortPlantRelationList: DryPortWetPortPlantRelationList[];
  productListForFclExportLiquidShipment: string[];
}

interface DryPortWetPortPlantRelationList {
  dryPortId: string;
  plantId: string;
  plantName: string;
}

interface ConditionTypeItemNameAndDescriptionList {
  conditionType: string;
  itemName: string;
  itemDescription: string;
  slabId: string;
}

interface ProductList {
  name: string;
  id: string;
  cargoType: string;
}

interface ShipmentSize {
  FCL: FCL3;
  LCL: LCL2;
  AIR: LCL2;
}

interface LCL2 {
  IMPORT: string;
  EXPORT: string;
}

interface FCL3 {
  EXPORT: string;
  IMPORT: string;
  CHARGES: string;
}

interface Incoterms {
  FCL: FCL2;
  LCL: FCL2;
  AIR: FCL2;
}

interface FCL2 {
  EXPORT: EXPORT2;
  IMPORT: IMPORT;
}

interface IMPORT {
  EXW: string;
  FOB: string;
  FCA: string;
}

interface EXPORT2 {
  CIF: string;
}

interface Region {
  code: string;
  name: string;
  rfqMode: string;
  rfqType: string;
  rfqSubType?: string;
}

interface ExcelFieldMap {
  lineItemExcelFieldMap: LineItemExcelFieldMap;
  lineItemExcelFieldMapForLocal: LineItemExcelFieldMapForLocal;
  bidExcelFieldMap: BidExcelFieldMap;
}

interface BidExcelFieldMap {
  nonCharges: NonCharges;
  charges: Charges;
}

interface Charges {
  oceanFreight: OceanFreight;
  bunkerCost: OceanFreight;
  destinationThc: OceanFreight;
  chasisCharges: OceanFreight;
  gstItemsCost: GstItemsCost;
  nonGstItemsCost: OceanFreight;
  destinationHaulageIfsCharge: GstItemsCost;
  sealCharges: GstItemsCost;
  loadPortNonHazThc: GstItemsCost;
  tollCharges: GstItemsCost;
  loloCharges: GstItemsCost;
  muc: GstItemsCost;
  miscellaneousPerBlCost: OceanFreight;
  nonHazDocChargesPerBl: GstItemsCost;
  flexiCharges: OceanFreight;
  hazCharges: OceanFreight;
  loadPortHazThc: GstItemsCost;
  hazDocChargesPerBl: GstItemsCost;
  overloadWeightCharges: GstItemsCost;
  chargesOnCollectBasisOnly: OceanFreight;
}

interface GstItemsCost {
  currency: string;
  amount: string;
}

interface OceanFreight {
  amount: string;
}

interface NonCharges {
  rfqId: string;
  customerContractNumber: string;
  originPortId: string;
  validityStartDate: string;
  validityEndDate: string;
  weightRestrictionOfCargo: string;
  stdWeightUom: string;
  stdWeightLimit: string;
  originFreeDays: string;
  originEquipmentFreeDays: string;
  destinationEquipmentFreeDays: string;
  destinationFreeDays: string;
  frequency: string;
  oceanTransitTimeInDays: string;
  noOfTranshipments: string;
  routing: string;
  totalTransitTimeInDays: string;
}

interface LineItemExcelFieldMapForLocal {
  id: string;
  originPorts: string;
  containerSize: string;
}

interface LineItemExcelFieldMap {
  id: string;
  originPorts: string;
  plants: string;
  destinationPort: string;
  tentativeContainers: string;
  containerSize: string;
  destinationCountry: string;
  cargoType: string;
  product: string;
  round: string;
  deadline: string;
  referenceRate: string;
  status: string;
  l1BidCost: string;
  l1BidOriginPort: string;
  l1BidShippingLine: string;
  l1BidValidFrom: string;
  l1BidValidTo: string;
  l2BidCost: string;
  l2BidOriginPort: string;
  l2BidShippingLine: string;
  l2BidValidFrom: string;
  l2BidValidTo: string;
  l3BidCost: string;
  l3BidOriginPort: string;
  l3BidShippingLine: string;
  l3BidValidFrom: string;
  l3BidValidTo: string;
  originFreeDays: string;
  originEquipmentFreeDays: string;
  destinationFreeDays: string;
  destinationEquipmentFreeDays: string;
  destinationCfsFreeDays: string;
}

interface TermsAndConditionsForRfq {
  id: string;
  text: string;
  organisationId: string;
  dropdownOptions?: string[];
  isManual: boolean;
  mandatory: boolean;
  type: string;
  subType?: string;
  mode: string;
  region: string;
}

interface LineItemStatusList {
  FCL: FCL;
  LCL: LCL;
  AIR: LCL;
}

interface LCL {
  EXPORT: CHARGES;
  IMPORT: CHARGES;
}

interface FCL {
  EXPORT: EXPORT;
  CHARGES: CHARGES;
  IMPORT: FclImport;
}

interface FclImport {
  // This tree is keyed [mode][type] with no sub-type level, so every FCL/IMPORT tender reads the same node.
  // Both import sub types (OCEAN_FREIGHT and FREIGHT_MANAGEMENT) now support the amendment flow, so the
  // backend always publishes AMENDMENT here — it stays optional only because the consumer reads it with
  // optional chaining and a `|| []` fallback, which is what keeps a missing branch from throwing.
  AMENDMENT?: AMENDMENT;
  NONAMENDMENT: AMENDMENT;
}

interface CHARGES {
  NONAMENDMENT: AMENDMENT;
}

interface EXPORT {
  AMENDMENT: AMENDMENT;
  NONAMENDMENT: AMENDMENT;
}

interface AMENDMENT {
  finalisedView: PLANT[];
  nonFinalisedView: PLANT[];
}

interface CustomCharge {
  code: string;
  name: string;
  currency: string;
  mode: string;
  type: string;
  subType?: string;
}

interface RfqPlanModeTypeAndSubTypeList {
  rfqPlanMode: string;
  rfqPlanType: string;
  rfqPlanSubType: string;
}

interface Permissions {
  RFQ_OPEN_LINE_ITEM: boolean;
  RFQ_PLAN_APPROVE_L1: boolean;
  RFQ_PLAN_APPROVE_L2: boolean;
  RFQ_PLAN_APPROVE_L3: boolean;
  RFQ_FINALISE_LINE_ITEM: boolean;
  RFQ_PLAN_FCL_EXPORT_SOLID_SHIPMENT_WRITE: boolean;
  RFQ_PLAN_FCL_EXPORT_LIQUID_SHIPMENT_WRITE: boolean;
  RFQ_PLAN_FCL_IMPORT_OCEAN_FREIGHT_WRITE: boolean;
  RFQ_PLAN_FCL_IMPORT_FREIGHT_MANAGEMENT_WRITE: boolean;
  RFQ_PLAN_FCL_IMPORT_FF_DIRECT_CONTRACT_WRITE: boolean;
  RFQ_PLAN_FCL_CHARGES_LOCAL_WRITE: boolean;
  RFQ_PLAN_FCL_CHARGES_ICD_WRITE: boolean;
  RFQ_PLAN_FCL_CHARGES_INCIDENTAL_WRITE: boolean;
  RFQ_PLAN_LCL_EXPORT_WRITE: boolean;
  RFQ_PLAN_LCL_IMPORT_WRITE: boolean;
  RFQ_PLAN_AIR_EXPORT_WRITE: boolean;
  RFQ_PLAN_AIR_IMPORT_WRITE: boolean;
  RFQ_PLAN_FCL_EXPORT_SOLID_SHIPMENT_VIEW: boolean;
  RFQ_PLAN_FCL_EXPORT_LIQUID_SHIPMENT_VIEW: boolean;
  RFQ_PLAN_FCL_IMPORT_OCEAN_FREIGHT_VIEW: boolean;
  RFQ_PLAN_FCL_IMPORT_FREIGHT_MANAGEMENT_VIEW: boolean;
  RFQ_PLAN_FCL_IMPORT_FF_DIRECT_CONTRACT_VIEW: boolean;
  RFQ_PLAN_FCL_CHARGES_LOCAL_VIEW: boolean;
  RFQ_PLAN_FCL_CHARGES_ICD_VIEW: boolean;
  RFQ_PLAN_FCL_CHARGES_INCIDENTAL_VIEW: boolean;
  RFQ_PLAN_LCL_EXPORT_VIEW: boolean;
  RFQ_PLAN_LCL_IMPORT_VIEW: boolean;
  RFQ_PLAN_AIR_EXPORT_VIEW: boolean;
  RFQ_PLAN_AIR_IMPORT_VIEW: boolean;
  RFQ_PLAN_BIDDING_FCL_EXPORT_SOLID_SHIPMENT_WRITE: boolean;
  RFQ_PLAN_BIDDING_FCL_EXPORT_LIQUID_SHIPMENT_WRITE: boolean;
  RFQ_PLAN_BIDDING_FCL_IMPORT_OCEAN_FREIGHT_WRITE: boolean;
  RFQ_PLAN_BIDDING_FCL_IMPORT_FREIGHT_MANAGEMENT_WRITE: boolean;
  RFQ_PLAN_BIDDING_FCL_IMPORT_FF_DIRECT_CONTRACT_WRITE: boolean;
  RFQ_PLAN_BIDDING_FCL_CHARGES_LOCAL_WRITE: boolean;
  RFQ_PLAN_BIDDING_FCL_CHARGES_ICD_WRITE: boolean;
  RFQ_PLAN_BIDDING_FCL_CHARGES_INCIDENTAL_WRITE: boolean;
  RFQ_PLAN_BIDDING_LCL_EXPORT_WRITE: boolean;
  RFQ_PLAN_BIDDING_LCL_IMPORT_WRITE: boolean;
  RFQ_PLAN_BIDDING_AIR_EXPORT_WRITE: boolean;
  RFQ_PLAN_BIDDING_AIR_IMPORT_WRITE: boolean;
  RFQ_PLAN_BIDDING_FCL_EXPORT_SOLID_SHIPMENT_VIEW: boolean;
  RFQ_PLAN_BIDDING_FCL_EXPORT_LIQUID_SHIPMENT_VIEW: boolean;
  RFQ_PLAN_BIDDING_FCL_IMPORT_OCEAN_FREIGHT_VIEW: boolean;
  RFQ_PLAN_BIDDING_FCL_IMPORT_FREIGHT_MANAGEMENT_VIEW: boolean;
  RFQ_PLAN_BIDDING_FCL_IMPORT_FF_DIRECT_CONTRACT_VIEW: boolean;
  RFQ_PLAN_BIDDING_FCL_CHARGES_LOCAL_VIEW: boolean;
  RFQ_PLAN_BIDDING_FCL_CHARGES_ICD_VIEW: boolean;
  RFQ_PLAN_BIDDING_FCL_CHARGES_INCIDENTAL_VIEW: boolean;
  RFQ_PLAN_BIDDING_LCL_EXPORT_VIEW: boolean;
  RFQ_PLAN_BIDDING_LCL_IMPORT_VIEW: boolean;
  RFQ_PLAN_BIDDING_AIR_EXPORT_VIEW: boolean;
  RFQ_PLAN_BIDDING_AIR_IMPORT_VIEW: boolean;
  INQUIRY_ALL_ACTIONS: boolean;
  INQUIRY_BIDDING_ALL_ACTIONS: boolean;
  CONTAINER_TRACKING_WRITE: boolean;
  CONTAINER_TRACKING_DELETE: boolean;
  IMPORTS_ACCESS_ALL_SHIPMENTS: boolean;
  IMPORTS_VIEW: boolean;
  IMPORTS_ADD: boolean;
  IMPORTS_DELETE: boolean;
  IMPORTS_EDIT: boolean;
  RATE_MASTER_VIEW: boolean;
  RATE_MASTER_EDIT: boolean;
  DISCOVER_BUY_RATES_VIEW: boolean;
  SHIPMENT_SHIPPER_VIEW: boolean;
  SHIPMENT_DO_ADD_EDIT_SHIPPER: boolean;
  SHIPMENT_TASK_ADD_EDIT_SHIPPER: boolean;
  SHIPMENT_TASK_DETAILS_DOCUMENTS_VIEW_SHIPPER: boolean;
  SHIPMENT_ALL_TASK_VIEW_SHIPPER: boolean;
  SHIPMENT_OWN_TASK_VIEW_SHIPPER: boolean;
  SHIPMENT_VENDOR_VIEW: boolean;
  SHIPMENT_DO_ADD_EDIT_VENDOR: boolean;
  SHIPMENT_TASK_ADD_EDIT_VENDOR: boolean;
  SHIPMENT_TASK_DETAILS_DOCUMENTS_VIEW_VENDOR: boolean;
  SHIPMENT_ALL_TASK_VIEW_VENDOR: boolean;
  SHIPMENT_OWN_TASK_VIEW_VENDOR: boolean;
  SHIPMENT_ADD_EDIT: boolean;
  USER_MANAGEMENT_WRITE: boolean;
}

export interface GlobalCarrier {
  label: string;
  id: string;
  name?: string;
  logoUrl?: string;
  isTrackingEnabled?: boolean;
  type?: string;
  dbId: string;
  isBookingSupported: boolean;
  scacCode?: string;
  termsAndConditions?: string;
}

interface GlobalShippingLine {
  id: string;
  name: string;
  logoUrl?: string;
  isTrackingEnabled?: boolean;
  type: string;
  dbId: string;
  isBookingSupported: boolean;
  scacCode?: string;
  termsAndConditions?: string;
}

interface UserData {
  type: string;
  id: string;
  username: string;
  name: string;
  email: string;
  phone?: any;
  role: string;
  status: string;
  tag: string;
  privacy_policy_accepted: boolean;
  organisationSize: ORGANISATION_SIZE;
}

interface Modules {
  show_rfq: boolean;
  show_play: boolean;
  show_logout: boolean;
  show_account: boolean;
  show_bidding: boolean;
  show_exports: boolean;
  show_imports: boolean;
  show_inquiry: boolean;
  show_masters: boolean;
  default_route: string;
  show_domestic: boolean;
  show_l1_to_ff: boolean;
  give_api_access: boolean;
  is_strategic_ff: boolean;
  show_dashboards: boolean;
  show_my_profile: boolean;
  show_rank_to_ff: boolean;
  show_markup_rate: string;
  show_new_exports: boolean;
  show_new_imports: boolean;
  show_rate_master: boolean;
  show_setup_users: boolean;
  cargo_wt_settings: boolean;
  show_rake_exports: boolean;
  show_rake_imports: boolean;
  show_rfq_analytics: boolean;
  show_rfq_rfq_plans: boolean;
  show_inttra_booking: boolean;
  show_bid_bulk_upload: boolean;
  show_exception_alert: boolean;
  show_exception_rules: boolean;
  show_inquiry_bidding: boolean;
  show_invoice_payable: boolean;
  show_user_management: boolean;
  show_inquiry_comments: boolean;
  show_vessel_schedules: boolean;
  show_domestic_tracking: boolean;
  show_inttra_booking_ff: boolean;
  show_master_categories: string[];
  show_setup_permissions: boolean;
  show_summary_dashboard: boolean;
  show_container_tracking: boolean;
  show_discover_buy_rates: boolean;
  show_invoice_receivable: boolean;
  is_custom_charge_allowed: boolean;
  show_exports_sales_order: boolean;
  show_imports_sales_order: boolean;
  show_inquiry_bulk_upload: boolean;
  show_shipping_management: boolean;
  is_bid_schedule_mandatory: boolean;
  show_notification_masters: string[];
  show_sell_rates_to_shipper: boolean;
  show_shipping_instructions: boolean;
  show_gap_for_rank1_all_bids: boolean;
  haz_cargo_documents_required: boolean;
  is_custom_charge_allowed_FCL: boolean;
  is_custom_charge_allowed_LCL: boolean;
  allow_self_raised_inquiry_bid: boolean;
  capture_reason_for_non_l1_bid: boolean;
  inquiry_creation_from_procure: boolean;
  show_exception_alert_instances: boolean;
  show_shipment_execution_vendor: boolean;
  show_container_tracking_exports: boolean;
  show_container_tracking_imports: boolean;
  show_domestic_customer_activity: boolean;
  show_shipment_execution_shipper: boolean;
  is_custom_charge_allowed_TRAILER: boolean;
  should_check_member_part_of_team: boolean;
  show_domestic_carrier_management: boolean;
  show_exception_alert_definitions: boolean;
  show_user_management_permissions: boolean;
  is_custom_charge_allowed_AIRCARGO: boolean;
  receive_inttra_booking_note_email: boolean;
  show_inttra_shipping_instructions: boolean;
  use_default_charge_master_bid_only: boolean;
  is_temperature_controlled_mandatory: boolean;
  use_default_charge_master_bid_only_FCL: boolean;
  use_default_charge_master_bid_only_LCL: boolean;
  send_email_on_closed_confirmed_inquiries: boolean;
  use_default_charge_master_bid_only_TRAILER: boolean;
  use_default_charge_master_bid_only_AIRCARGO: boolean;
  use_organisation_specific_charge_values_from_default: boolean;
  use_organisation_specific_charge_values_from_default_FCL: boolean;
  use_organisation_specific_charge_values_from_default_LCL: boolean;
  use_organisation_specific_charge_values_from_default_TRAILER: boolean;
  use_organisation_specific_charge_values_from_default_AIRCARGO: boolean;
}

interface PlantToLoadingPortsMap {
  'ADANI HAZIRA': PLANT[];
  'TANJUNG PELEPAS': PLANT[];
  'JOHOR PORT': PLANT[];
  'KEMAMAN PORT': PLANT[];
  'KUANTAN PORT': PLANT[];
  'NHAVA SHEVA': PLANT[];
  'PENANG PORT': PLANT[];
  'PORT KLANG': PLANT[];
  'BINTULU PORT': PLANT[];
  JAMNAGAR: PLANT[];
}

interface DimensionData {
  PLANT: PLANT[];
  CHA: PLANT[];
  FF: PLANT[];
  SHIPPER: PLANT[];
  SHIPPING_LINE: PLANT[];
}

interface PLANT {
  id: string;
  name: string;
}

interface SortBy {
  BL: BL;
  SHIPMENT: BL;
  CONTAINER: BL;
}

interface BL {
  sortBy: string;
  descendingOrder: boolean;
}

const masterDataProto = {} as MasterData;
export default masterDataProto;
